module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main_wrap"
  }, [_c('NavTab'), _vm._v(" "), _c('div', {
    staticClass: "form_case"
  }, [_c('el-form', {
    ref: "my_form",
    staticClass: "my_form",
    attrs: {
      "inline": "",
      "model": _vm.model,
      "label-width": "80px",
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属单位",
      "prop": "firstOrganizationId"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择支队"
    },
    on: {
      "change": _vm.onSelectZhidui
    },
    model: {
      value: (_vm.model.firstOrganizationId),
      callback: function($$v) {
        _vm.$set(_vm.model, "firstOrganizationId", $$v)
      },
      expression: "model.firstOrganizationId"
    }
  }, _vm._l((_vm.zhiduiLists), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.fullName,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "secondOrganizationId"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择大队"
    },
    model: {
      value: (_vm.model.secondOrganizationId),
      callback: function($$v) {
        _vm.$set(_vm.model, "secondOrganizationId", $$v)
      },
      expression: "model.secondOrganizationId"
    }
  }, _vm._l((_vm.daduiLists), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.fullName,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "类型",
      "prop": "type"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.type),
      callback: function($$v) {
        _vm.$set(_vm.model, "type", $$v)
      },
      expression: "model.type"
    }
  }, _vm._l((_vm.caseTypeLists), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预约时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "start-placeholder": "开始时间",
      "range-separator": "至",
      "end-placeholder": "结束时间",
      "type": "daterange",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.timeValue),
      callback: function($$v) {
        _vm.timeValue = $$v
      },
      expression: "timeValue"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "my_btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fetchData
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "my_btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onExport
    }
  }, [_vm._v("导出")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table_wrap"
  }, [_c('div', {
    staticClass: "my_table"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "header-cell-style": _vm.tableHeaderStyle,
      "cell-style": _vm.tableCellStyle,
      "show-summary": "",
      "summary-method": _vm.getSummaries
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "200px",
      "align": "center",
      "label": "所属单位",
      "prop": "firstOrganizationName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "250px",
      "align": "center",
      "label": "所属单位",
      "prop": "secondOrganizationName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "100px",
      "align": "center",
      "label": "类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.type == null || scope.row.type == "" ? "" : scope.row.type == 2 ? "一般程序" : "简易程序"))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "100px",
      "align": "center",
      "label": "总量数",
      "prop": "allNum"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "100px",
      "align": "center",
      "label": "小程序新建",
      "prop": "initedNum"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "100px",
      "align": "center",
      "label": "PC端新建",
      "prop": "pcInitedNum"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "100px",
      "align": "center",
      "label": "暂存",
      "prop": "savedNum"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "100px",
      "align": "center",
      "label": "全流程完成",
      "prop": "finishedNum"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "100px",
      "align": "center",
      "label": "处置终止",
      "prop": "stoppedNum"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "100px",
      "align": "center",
      "label": "手动取消",
      "prop": "cancelledNum"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "100px",
      "align": "center",
      "label": "超时取消",
      "prop": "timeoutCancelledNum"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "100px",
      "align": "center",
      "label": "接警人超时取消",
      "prop": "policeTimeoutCancelledNum"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "100px",
      "align": "center",
      "label": "当事人超时取消",
      "prop": "reporterTimeoutCancelledNum"
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4c9001a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/count/count.vue
// module id = YWwU
// module chunks = 6